export const resetFolderToInbox = "oq4XNd";
export default {resetFolderToInbox};